import { currenciesConstants } from "../constants/action.constants";

const initialState = {
  fetching: false,
  fetched: false,
  response: null,
  error: null
};

export const currencies = (state = initialState, action) => {
  switch (action.type) {
    case currenciesConstants.GET_CURRENCIES_REQUEST:
      return {
        ...state,
        fetching: true
      };
    case currenciesConstants.GET_CURRENCIES_SUCCESS:
      return {
        ...state,
        fetching: false,
        fetched: true,
        response: action.response,
        error: null
      };
    case currenciesConstants.GET_CURRENCIES_FAILURE:
      return {
        ...state,
        fetching: false,
        fetched: false,
        error: action.error
      };
    case currenciesConstants.GET_CURRENCIES_RESET:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
